import React, { useEffect, useState } from 'react';
import './css/tax-packages.css';
import ContactFormSection from '../contactUsComponent/contact-form-section';
import RegistrationPackages from './taxPackageComponents/taxServices-registration-packages';
import IndividualConsultationPackages from './taxPackageComponents/taxServices-individual-packages';
import OrganizationPackages from './taxPackageComponents/taxServices-organization-packages';

export default function TaxPackages() {
	const [selectedPackage, setSelectedPackage] = useState(null);
	const requiresRegistrationFields =
		selectedPackage?.label === 'Tax Payer Registration' && selectedPackage?.name === 'TIN registration';

	useEffect(() => {
		if (!selectedPackage) {
			return undefined;
		}

		const originalOverflow = document.body.style.overflow;
		document.body.style.overflow = 'hidden';

		const handleKeyDown = (event) => {
			if (event.key === 'Escape') {
				setSelectedPackage(null);
			}
		};

		document.addEventListener('keydown', handleKeyDown);

		return () => {
			document.body.style.overflow = originalOverflow;
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [selectedPackage]);

	const handleRequest = (packageItem) => {
		setSelectedPackage(packageItem);
	};

	const handleCloseRequest = () => {
		setSelectedPackage(null);
	};

	return (
		<section className="tax-packages-section">
			<div className="tax-packages-section__inner">
				{selectedPackage ? (
					<div className="tax-request-modal" role="presentation" onClick={handleCloseRequest}>
						<section
							className="tax-request-modal__dialog"
							id="tax-service-request"
							role="dialog"
							aria-modal="true"
							aria-labelledby="tax-request-title"
							onClick={(event) => event.stopPropagation()}
						>
							<button
								className="tax-request-modal__close"
								type="button"
								onClick={handleCloseRequest}
								aria-label="Close request form"
							>
								×
							</button>
							<div className="tax-request-panel__header">
								<h3 id="tax-request-title">{selectedPackage.name}</h3>
							</div>
							<ContactFormSection
								title=""
								selectedPackage={selectedPackage}
								compact={requiresRegistrationFields}
								className="tax-request-panel__form"
							/>
						</section>
					</div>
				) : null}
                <h2>Choose the Right Plan for Your Tax Needs</h2>
				<RegistrationPackages onRequest={handleRequest} />
				<IndividualConsultationPackages onRequest={handleRequest} />
				<OrganizationPackages onRequest={handleRequest} />
			</div>
		</section>
	);
}